import React, { useState, useEffect } from 'react';
import SpinnerCard from '../../SpinnerCard.js';
import { Container, Row, Card } from 'react-bootstrap';
import { getMomentDate } from '../../CalendarUtil.js';

function JournalHistory(props) {

    var [isLoading, setIsLoading] = useState(false);
    var [journalEntries, setJournalEntries] = useState([]);

    useEffect(() => {
        const fetchJournalEntries = async () => {
            setIsLoading(true);
            const query = `/api/journalEntries?petid=${props.petId}`;
            const res = await fetch(query,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    cors: 'cors'
                });
            const resJson = await res.json();
            setJournalEntries(resJson);
            setIsLoading(false);
        }
        if (props.petId) {
            fetchJournalEntries();
        }
        // eslint-disable-next-line
    }, [props.petId, props.reloadData]);

    function getEntries() {
        const entries = journalEntries.map((e, i) => (
            <React.Fragment key={i}>
                <Row style={{marginBottom: '20px'}}>
                    <Card style={{width: '100%'}}>
                        <Card.Header>{getMomentDate(new Date(e.FirstCreatedAt)).format('YYYY-MM-DD HH:mm')} - {e.CreatedByInitials}</Card.Header>
                        <Card.Body>
                            <Card.Text style={{whiteSpace: 'pre-line'}}>{e.Note}</Card.Text>
                        </Card.Body>
                    </Card>
                </Row>
            </React.Fragment>
        ));
        return entries;
    }

    if (!props.shown) {
        return <React.Fragment></React.Fragment>;
    }
    else if (isLoading) {
        return <SpinnerCard></SpinnerCard>;
    }
    else {
        return (
            <React.Fragment>
                <hr />
                <h2>Journalhistorik</h2>
                <hr />
                <Container>
                    {getEntries()}
                </Container>
            </React.Fragment>
        );
    }

}

export default JournalHistory;